import { useEffect, useState } from "react";
import { Video } from "./index";
import { Button } from "../Actions";

export const VideoGrid: React.FC<{
  showDescription?: boolean;
  videos: any[];
  sizes?: { max: number; min: number };
  maxVideos: { mobile: number; desktop: number };
  paginate?: boolean;
  containerClassName?: string;
}> = ({
  videos,
  sizes,
  showDescription,
  maxVideos,
  paginate,
  containerClassName
}) => {
  const sizeClass = sizes ? `size-${sizes.max}-${sizes.min}` : "";
  const [videosShowing, setVideosShowing] = useState<any[]>([]);
  const [showMore, setShowMore] = useState({ page: 1, showButton: false });
  const [MAX_VIDS, setMAX_VIDS] = useState(maxVideos.desktop);

  const [mQuery, setMQuery] = useState<any>({ matches: true });
  useEffect(() => {
    let mediaQuery = window.matchMedia("(min-width: 820px)");
    setMQuery(mediaQuery);
    mediaQuery.addListener(setMQuery); // this is the cleanup function to remove the listener
    return () => mediaQuery.removeListener(setMQuery);
  }, []);

  useEffect(() => {
    if (mQuery?.matches) {
      setMAX_VIDS(maxVideos.desktop);
    } else {
      setMAX_VIDS(maxVideos.mobile);
    }
  }, [mQuery.matches, maxVideos]);

  const handleSetShowMore = () => {
    const totalVids = videos.length;
    const maxShown = MAX_VIDS * showMore.page;
    if (totalVids > maxShown) {
      const maxVids = (showMore.page + 1) * MAX_VIDS;
      const slicedVids = videos.slice(0, maxVids);
      setVideosShowing(slicedVids);
      setShowMore({
        page: showMore.page + 1,
        showButton: totalVids > maxVids
      });
    }
  };

  useEffect(() => {
    const slicedVids = videos.slice(0, MAX_VIDS);
    if (videos.length > MAX_VIDS && paginate) {
      setVideosShowing(slicedVids);
      setShowMore({ page: 1, showButton: true });
    } else {
      setVideosShowing(slicedVids);
    }
  }, [videos, paginate, MAX_VIDS]);

  return (
    <>
      {sizes && (
        <style
          dangerouslySetInnerHTML={{
            __html: `.${sizeClass}{
  --vidGrid-max: ${sizes.max}px;
  --vidGrid-min: ${sizes.min}px;
  }
`
          }}></style>
      )}
      <div className={`pb-8 ${containerClassName}`}>
        <section className={`videoGrid ${sizeClass}`}>
          {videosShowing.map(video => (
            <>
              <Video
                key={video.urlSlug}
                showDescription={showDescription ?? true}
                video={video}
              />
            </>
          ))}
        </section>
        {showMore.showButton ? (
          <div className="flex justify-center w-full mt-8">
            <Button
              modifier="primary"
              analyticsProperty="showMore"
              onClick={handleSetShowMore}>
              View More
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
};
